import script from "./NotificationBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationBar.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationBar.vue?vue&type=style&index=0&id=37d876f8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d876f8"]])

export default __exports__